<div class="backdrop" *ngIf="backdrop"></div>

<input [colorPicker]="color" (colorPickerOpen)="setBackdrop(true)"
       [disabled]="disabled"
       [value]="color"
      [cpPresetColors]="presets" (colorPickerClose)="setBackdrop(false)" [cpOutputFormat]="'hex'"
      [cpAlphaChannel]="'disabled'" (colorPickerChange)="color = $event"
      [style.background]="color" [style.color]="getTextColor(color)">

<!--<ng-container *ngIf="disabled; else enabled">-->
<!--  <input type="text" [disabled]="disabled" [value]="color"-->
<!--         [style.background]="color" [style.color]="getTextColor(color)">-->
<!--</ng-container>-->
<!--<ng-template #enabled>-->
<!--  <compact-picker [control]="compactControl" (colorChange)="color = $event"></compact-picker>-->
<!--&lt;!&ndash;  <span [style.background]="color" [colorPicker]="color" (colorPickerOpen)="setBackdrop(true)"&ndash;&gt;-->
<!--&lt;!&ndash;         [cpDialogDisplay]="'inline'"&ndash;&gt;-->
<!--&lt;!&ndash;         [cpToggle]="true"&ndash;&gt;-->
<!--&lt;!&ndash;         [cpPresetColors]="presets" (colorPickerClose)="setBackdrop(false)" [cpOutputFormat]="'hex'"&ndash;&gt;-->
<!--&lt;!&ndash;         [cpAlphaChannel]="'disabled'" (colorPickerChange)="color = $event"&ndash;&gt;-->
<!--&lt;!&ndash;        [style.background]="color" [style.color]="getTextColor(color)"></span>&ndash;&gt;-->
<!--</ng-template>-->

